import { merge } from "lodash-es";
// IMPLEMENTATION
export const makeCartApi = (options) => {
    const { baseUrl, errorMessages, headerNonceKey, headerTokenKey, localStorageNonceKey, localStorageTokenKey, } = merge({
        baseUrl: process.env.NEXT_PUBLIC_STORE_API_URL ?? "",
        errorMessages: {
            500: "Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut oder kontaktiere uns unter support@culinario-mortale.de",
        },
        headerNonceKey: "Nonce",
        headerTokenKey: "Cart-Token",
        localStorageNonceKey: "cm-cart-session",
        localStorageTokenKey: "cm-cart-token",
    }, options);
    if (!baseUrl)
        throw new Error("ProductApi expects baseUrl to be set");
    /**
     * WooCommerce store api uses nonces and jwts to pass session information between client and backend.
     * We need to extract both from API response headers and store them in LocalStorage for later use.
     */
    const storeNonce = (session) => {
        if (!session || session.length === 0)
            return;
        localStorage.setItem(localStorageNonceKey, session);
    };
    const storeToken = (token) => {
        if (!token || token.length === 0)
            return;
        localStorage.setItem(localStorageTokenKey, token);
    };
    const getNonce = () => {
        if (typeof window === "undefined")
            return;
        return localStorage.getItem(localStorageNonceKey);
    };
    const getToken = () => {
        if (typeof window === "undefined")
            return;
        return localStorage.getItem(localStorageTokenKey);
    };
    const getNonceOrThrow = () => {
        const session = getNonce();
        if (!session)
            throw new Error("WooCommerce session not set");
        return session;
    };
    const getTokenOrThrow = () => {
        const token = getToken();
        if (!token)
            throw new Error("WooCommerce cart token not set");
        return token;
    };
    const extractAndStoreHeader = (key, persistFn) => (headers) => {
        if (headers.has(key)) {
            const value = headers.get(key);
            if (value)
                persistFn(value);
        }
    };
    const extractAndStoreNonce = extractAndStoreHeader(headerNonceKey, storeNonce);
    const extractAndStoreToken = extractAndStoreHeader(headerTokenKey, storeToken);
    return {
        addItem: async ({ id, quantity }) => {
            const endpoint = `${baseUrl}/wp-json/wc/store/v1/cart/add-item`;
            const nonce = getNonce();
            const token = getToken();
            const res = await fetch(endpoint, {
                method: "POST",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                    [headerNonceKey]: nonce ?? "",
                    [headerTokenKey]: token ?? "",
                },
                body: JSON.stringify({ id, quantity }),
            });
            if (!res.ok) {
                const data = await res.json();
                const message = data?.message ?? errorMessages[500];
                throw new Error(message);
            }
            else {
                extractAndStoreNonce(res.headers);
                extractAndStoreToken(res.headers);
            }
        },
        get: async () => {
            const endpoint = `${baseUrl}/wp-json/wc/store/v1/cart`;
            console.log(endpoint);
            const token = getToken();
            const res = await fetch(endpoint, {
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                    [headerTokenKey]: !!token ? token : "",
                },
            });
            extractAndStoreNonce(res.headers);
            extractAndStoreToken(res.headers);
            const cart = await res.json();
            return cart;
        },
        getSession: () => ({
            id: getNonce() ?? "",
            token: getToken() ?? "",
        }),
        removeItem: async ({ key }) => {
            const endpoint = `${baseUrl}/wp-json/wc/store/v1/cart/remove-item`;
            const nonce = getNonceOrThrow();
            const token = getTokenOrThrow();
            const res = await fetch(endpoint, {
                method: "POST",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                    [headerNonceKey]: nonce,
                    [headerTokenKey]: token,
                },
                body: JSON.stringify({ key }),
            });
            if (!res.ok) {
                const data = await res.json();
                const message = data?.message ?? errorMessages[500];
                throw new Error(message);
            }
            else {
                extractAndStoreNonce(res.headers);
                extractAndStoreToken(res.headers);
            }
        },
        updateItem: async ({ key, quantity }) => {
            const endpoint = `${baseUrl}/wp-json/wc/store/v1/cart/update-item`;
            const nonce = getNonceOrThrow();
            const token = getTokenOrThrow();
            const res = await fetch(endpoint, {
                method: "POST",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                    [headerNonceKey]: nonce,
                    [headerTokenKey]: token,
                },
                body: JSON.stringify({ key, quantity }),
            });
            if (!res.ok) {
                const data = await res.json();
                const message = data?.message ?? errorMessages[500];
                throw new Error(message);
            }
            else {
                extractAndStoreNonce(res.headers);
                extractAndStoreToken(res.headers);
            }
        },
    };
};
//# sourceMappingURL=api.js.map